import { Badge } from '@dnb/eufemia';
import { Fragment, ReactNode } from 'react';

import style from './index.module.css';

interface AccessRow {
  label: ReactNode;
  hasTestAccess?: boolean;
  hasLiveAccess?: boolean;
}

interface Props {
  rows: AccessRow[];
}

export function AccessGrid({ rows }: Props) {
  return (
    <div className={style['AccessGrid']}>
      {rows.map((row, index) => (
        <Fragment key={index}>
          {row.label}
          <div className={style['BadgeContainer']}>{row.hasTestAccess && <Badge content="Test" />}</div>
          <div className={style['BadgeContainer']}>
            {row.hasLiveAccess && <Badge content="Live" status="positive" />}
          </div>
        </Fragment>
      ))}
    </div>
  );
}
